import { animated, AnimatedComponent } from '@react-spring/web';

import styled from '@tanium/react-emotion-9';

export const CrispLine: AnimatedComponent<'line'> = styled(animated.line)({
  shapeRendering: 'crispEdges',
}) as unknown as AnimatedComponent<'line'>;
